import { Button, Dropdown, Space, Modal, message } from 'antd';
import type { MenuProps } from 'antd';
import { DownOutlined, SyncOutlined } from '@ant-design/icons';
import { ProductState } from '@tcr-erp/shared';
import { PRODUCT_STATE_LABEL } from '../parts/constants';

interface BulkToolbarProps {
  count: number;
  loading?: boolean;
  onStateChange: (state: ProductState) => void;
  onClear: () => void;
  /** TCR-2484: mở popup chuyển danh mục. Không truyền (không có quyền sửa) thì ẩn mục này. */
  onMoveCategory?: () => void;
}

const BULK_STATE_ACTIONS: Array<{ state: ProductState; titleVerb: string }> = [
  { state: ProductState.ACTIVE, titleVerb: 'Hiển thị' },
  { state: ProductState.INACTIVE, titleVerb: 'Ẩn' },
  { state: ProductState.DRAFT, titleVerb: 'Chuyển sang nháp' },
];

export function BulkToolbar({ count, loading, onStateChange, onClear, onMoveCategory }: BulkToolbarProps) {
  const stateMenuItems: MenuProps['items'] = BULK_STATE_ACTIONS.map(({ state, titleVerb }) => ({
    key: String(state),
    label: PRODUCT_STATE_LABEL[state],
    onClick: () => {
      Modal.confirm({
        title: `${titleVerb} ${count} sản phẩm?`,
        okText: 'Xác nhận',
        cancelText: 'Huỷ',
        onOk: () => onStateChange(state),
      });
    },
  }));
  const menuItems: MenuProps['items'] = onMoveCategory
    ? [...stateMenuItems, { type: 'divider' }, { key: 'move-category', label: 'Chuyển danh mục', onClick: onMoveCategory }]
    : stateMenuItems;

  return (
    // Dính liền mép trên của bảng: không bo góc, không viền, không khoảng hở.
    <div
      style={{
        background: '#fff6f8',
        padding: '8px 12px',
      }}
    >
      <Space>
        <Button danger onClick={onClear}>
          Bỏ chọn
        </Button>
        <span>
          Đã chọn <strong>{count}</strong> sản phẩm
        </span>
        <Dropdown menu={{ items: menuItems }} trigger={['click']}>
          <Button loading={loading}>
            Thao tác <DownOutlined />
          </Button>
        </Dropdown>
        <Button
          icon={<SyncOutlined />}
          onClick={() => void message.info('Tính năng đang phát triển')}
        >
          Đồng bộ MISA ({count} SP)
        </Button>
      </Space>
    </div>
  );
}
